
import { Poker2SoundController } from "../../../controller/Poker2SoundController";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2SitnGoResultDialogProperties } from "./Poker2SitnGoResultDialogProperties";

import { NumberStringHelper } from "../../../helper/NumberStringHelper";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2SitnGoResultDialog extends Poker2Dialog {
    public static NAME: string = "Poker2SitnGoResultDialog";

    constructor(disp: Container) {
        super(disp);
    }

    protected applyProperties(): void {
        // buttons
        this.resultDialog.btn_ok.label = Poker2Model.languageData.getTextById("generic_btn_okay");

        // rank display
        this.resultDialog.txt_rank.text = String(this.dialogProperties.tournamentResultVO.rank);
        this.resultDialog.txt_rank_title.text = Poker2Model.languageData.getTextById("dialog_tournament_subtitle");

        // texts
        this.resultDialog.txt_title.text = this.dialogProperties.tournamentResultVO.txtTitle;
        this.resultDialog.txt_copy.text = this.dialogProperties.tournamentResultVO.txtCopy;

        // chips
        this.resultDialog.txt_chips.text = NumberStringHelper.groupString(this.dialogProperties.tournamentResultVO.chips, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));

        // sound
        this.playResultSound();
    }

    private playResultSound(): void {
        if (this.dialogProperties.tournamentResultVO.rank == 1) {
            this.controller.soundController.playSoundEffectByName(Poker2SoundController.SND_WIN);
        }
        else {
            this.controller.soundController.playSoundEffectByName(Poker2SoundController.SND_LOSE);
        }
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);

        switch (event.target) {
            case this.resultDialog.btn_ok:
                this.hide();
                break;
        }
    }

    protected get dialogProperties(): Poker2SitnGoResultDialogProperties {
        return this.properties as Poker2SitnGoResultDialogProperties;
    }

    protected get resultDialog(): Library.PokerPopUps.PokerTourResult3 {
        return this.disp as Library.PokerPopUps.PokerTourResult3;
    }
}
